<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Hi {{clientInvite.invitee.firstName}}, let's get started!</h1>
    <p>Thank you for choosing Qtac, we need some information to get you started.</p>
    <p>We will use this information to create your account, complete our identity verification checks, and issue your contract.</p>
    <p>To speed things up, please provide your company registration number below, this will allow us to retrieve the information that we need.</p>
  </div>


    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
        <label class="strong" for="coregno">Company Registration Number</label>
        <input 
          type="text" 
          id="coregno" 
          name="coregno" 
          placeholder="" 
          v-model="formData.companyNumber" 
          required 
          @input="formData.companyNumber = formData.companyNumber.replace(/[^a-zA-Z0-9]/g, '').slice(0, 8)">
        <label>
          <a @click.prevent="showHelp = !showHelp">I need help finding my company registration number</a>
        </label>
      </form>
      </div>
      <div v-if="showHelp" class="cell small-8 help-panel">
        You can find your company registration number by visiting <a href="https://find-and-update.company-information.service.gov.uk/" target="_blank" rel="noopener">Companies House</a>.
      </div>

</template>


<script setup>

import { ref, defineEmits } from 'vue'

const error = ref(null)
const showHelp = ref(false) 

const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {

  if (!props.formData.companyNumber) {
    error.value = 'Please provide your company registration number';
    return false;
  }

if (!/^[a-zA-Z0-9]{8}$/.test(props.formData.companyNumber)) {
  error.value = 'Please provide a valid company registration number';
  return false;
}

  if (props.formData.companyNumber.length !== 8) {
    error.value = 'Please provide a valid company registration number';
    return false;
  }

  return true;
}

const emit = defineEmits(['update-form']);
import { getCompaniesHouseSummary } from '@/services/companieshousemanager.func';
const errorMessage = 'Sorry, we\'ve been unable to locate your company with Companies House, please check your company number and try again.';
const executeStep = async () => {
    try {
    const res = await getCompaniesHouseSummary(props.formData.companyNumber);

    if(res.status !== 200) {
      error.value = errorMessage;
      return false;
    }

    if(!checkIfCompanyActive(res.data)) {
      error.value = 'Your company is not active. Please contact your Qtac account manager.';
      return false;
    }

    var mappedResponse = companiesHouseResponseMapper(res.data);
    emit('update-form', mappedResponse);
  } catch (err) {
    error.value = errorMessage;
  }

  if(mappedResponse === undefined) {
    error.value = 'An error has occurred while locating your company. Please contact your Qtac account manager.';
    return false;
  }

  return true;
}

const checkIfCompanyActive = (res) => {
  return (res.company_status == 'active');
}

const companiesHouseResponseMapper = (res) => {

  const updatedFormData = {
    ...props.formData,
    name: res.company_name,
    address: {
      addressLine1: res.registered_office_address.address_line_1,
      addressLine2: res.registered_office_address.address_line_2,
      addressLine3: res.registered_office_address.locality,
      addressLine4: res.registered_office_address.country,
      postCode: res.registered_office_address.postal_code
    },
    contacts: []
  };

  return updatedFormData;
  
};


defineExpose({ validateStep, executeStep });

</script>